import { useState, useCallback, useEffect } from 'react'
import { useCADPageStore } from '@/state'

type UseCustomPanelSizeOptions = {
  panelId: string
  defaultWidthPx: number
}

export const useCustomPanelSize = ({
  panelId,
  defaultWidthPx,
}: UseCustomPanelSizeOptions) => {
  const storedWidthPx = useCADPageStore((state) => state.panelWidthsPx[panelId])
  const setPanelWidthPx = useCADPageStore((state) => state.setPanelWidthPx)

  const [width, setWidth] = useState(storedWidthPx ?? defaultWidthPx)

  useEffect(() => {
    if (storedWidthPx !== undefined) {
      setWidth(storedWidthPx)
    }
  }, [storedWidthPx])

  const handleResize = useCallback(
    (_e: any, _direction: any, ref: HTMLElement) => {
      const newWidth = ref.offsetWidth
      setWidth(newWidth)
      setPanelWidthPx(panelId, newWidth)
    },
    [panelId, setPanelWidthPx],
  )

  return {
    width,
    handleResize,
  }
}
